import React from "react";

interface Props {
  children: React.ReactNode;
  className?: string;
}

/// Inline error text used by connection editors and side panels.
/// Single visual style: small muted-size, error color, `role="alert"`
/// so screen readers announce on appearance. Long messages should be
/// shortened upstream (see `bucketApi.ts::mapError` and
/// `server/src/api/buckets/errors.rs`) rather than wrapped here.
export const InlineError: React.FC<Props> = ({ children, className }) => (
  <p
    role="alert"
    className={`text-fg-muted-regular-small text-error ${className ?? ""}`}
  >
    {children}
  </p>
);
